import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import '../../../src/index.scss';

class NotSignedInPitch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pid: this.props.pid
        }
    }

    render(){
        return (
            <div><br />
                <div className="row">
                    <div className="col-sm-12">
                        <div style={{padding: '12px', margin: '50px', backgroundColor: '#dddddd'}}>
                            <h3>Have you Logged In?  Have you created an account?</h3>
                            <div style={{padding: '12px', margin: '12px', backgroundColor: '#dddddd'}}>
                                <p>You need to have a free account with Impact Tournaments, and be logged in, to interact with or create tournaments.</p>
                                <p>You may login or create a free account by going <strong><Link to="/pages/login">HERE</Link></strong>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default NotSignedInPitch;